import { DataQueueDetailUIModel } from "src/store/models/ui/dataQueue/dataQueueDetail";
import { DataQueueSideUIModel } from "src/store/models/ui/dataQueue/dataQueueSide";
import { DataQueueTableUIModel } from "src/store/models/ui/dataQueue/dataQueueTable";

export const encooDataQueueUIModels = {
  dataQueueTable: DataQueueTableUIModel,
  dataQueueSide: DataQueueSideUIModel,
  dataQueueDetail: DataQueueDetailUIModel,
};
